exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-link a{font-family:ProximaNova-Semibold;font-size:14px;font-weight:400;font-style:normal;font-stretch:normal;color:#fff;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpLink/adpLink.less
// module id = 528
// module chunks = 0